/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Token_Icon_Breakdown_HeadingInputs */

const en_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breakdown`)
};

const de_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufschlüsselung`)
};

const pt_br2_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhamento`)
};

const tr_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağılım`)
};

const zh_cn2_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明细`)
};

const zh_hk2_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明細`)
};

const ko_kr2_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세부 내역`)
};

const ru_ru2_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состав`)
};

const es_419_components_token_icon_breakdown_heading = /** @type {(inputs: Components_Token_Icon_Breakdown_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desglose`)
};

/**
* | output |
* | --- |
* | "Breakdown" |
*
* @param {Components_Token_Icon_Breakdown_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_breakdown_heading = /** @type {((inputs?: Components_Token_Icon_Breakdown_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_Breakdown_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_breakdown_heading(inputs)
	if (locale === "de") return de_components_token_icon_breakdown_heading(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_breakdown_heading(inputs)
	if (locale === "tr") return tr_components_token_icon_breakdown_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_breakdown_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_breakdown_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_breakdown_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_breakdown_heading(inputs)
	return es_419_components_token_icon_breakdown_heading(inputs)
});